// extracted by mini-css-extract-plugin
export default {"root":"MoveToEditorToggle_root__NNEHd"};